export class AppNotifications {
  public static readonly emailInventoryPurchase: string =
    'email-inventory-purchase';
  public static readonly emailInventorySale: string = 'email-inventory-sale';
  public static readonly emailDailySummary: string = 'email-daily-summary';
  public static readonly emailPaymentComplete: string =
    'email-payment-complete';
  public static readonly emailWeeklySportsReport: string =
    'email-weekly-sports-report';
}
